if (!customElements.get("c-modal-media")) {
  customElements.define(
    "c-modal-media",
    class ComponentModalMedia extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.swiper = new Swiper(".js-modal-media__swiper", {
          spaceBetween: 0,
          slidesPerView: 1,
        });

        this.btnPrev = this.querySelector(".js-modal-media__button--prev");
        this.btnNext = this.querySelector(".js-modal-media__button--next");

        this.currentSlide = this.querySelector(".js-modal-media__current-slide");

        this.btnClose = this.querySelector(".js-modal-media__close");

        this.btnPrev.addEventListener("click", this.prevSlide);
        this.btnNext.addEventListener("click", this.nextSlide);

        this.btnClose.addEventListener("click", this.closer)

        this.slideChange()

        this.swiper.on('slideChange', () => {
          this.slideChange();
        });

        this.openUnsubscriber = window.PubSub.subscribe('modal-media', (index) => {
          this.opener(index)
        });
      }

      disconnectedCallback() {
        this.openUnsubscriber();
        this.btnPrev.removeEventListener("click", this.prevSlide);
        this.btnNext.removeEventListener("click", this.nextSlide);

        this.btnClose.removeEventListener("click", this.closer)
      }

      opener = (index = 0) => {
        this.classList.add("is-open")
        this.swiper.slideTo(index)
        document.body.classList.add("modal-open")
      }

      closer = () => {
        this.classList.remove("is-open");
        document.body.classList.remove("modal-open")
      }

      slideChange = () => {
        if(this.swiper.isEnd) {
          this.btnNext.style = "opacity: 0.5; pointer-events: none;"
        } else {
          this.btnNext.style = "opacity: 1;"
        }

        if(this.swiper.isBeginning) {
          this.btnPrev.style = "opacity: 0.5; pointer-events: none;"
        } else {
          this.btnPrev.style = "opacity: 1;"
        }

        this.currentSlide.innerHTML = this.swiper.realIndex + 1
      }

      prevSlide = () => {
        this.swiper.slidePrev();
      }

      nextSlide = () => {
        this.swiper.slideNext();
      }
    }
  );
}
